
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/instructor-terms",
      function () {
        return require("private-next-pages/instructor-terms.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/instructor-terms"])
      });
    }
  